import { SelectedPatient } from '@appyvet/vetbooker-definitions/dist/appointments';
import { BehaviorSubject } from 'rxjs';
import { Resource } from '@appyvet/vetbooker-definitions/dist/resource';
import { Router } from '@angular/router';

export const getBookingUrl = (
  selectedPatients: SelectedPatient[],
  selectedDate$: BehaviorSubject<Date>,
  selectedResource$: BehaviorSubject<Resource>,
  router: Router,
): string => {
  const passedPatientParams = [];
  selectedPatients.forEach((selectedPatient) => {
    // Only change params if not default patient, i.e. has patient number
    if (selectedPatient.patient.patientNumber) {
      passedPatientParams.push({
        patientId: selectedPatient.patient.patientNumber,
        appointmentType: selectedPatient.selectedAppointmentType?.objectId,
        notes: selectedPatient.notes,
      });
    }
  });
  const urlParams = {
    patients: JSON.stringify(passedPatientParams),
  } as any;
  let dateStr: string;
  dateStr = selectedDate$?.getValue().toJSON();
  if (dateStr) {
    urlParams.date = dateStr;
  }
  if (selectedResource$.getValue()) {
    urlParams.resourceId = selectedResource$.getValue().objectId;
  }

  const url = router.createUrlTree(['/booking', urlParams]).toString();

  return url;
};
